const article = {
  breadcrumbHome: "首页",
  breadcrumbCategory: "分类",
  breadcrumbArticle: "文章",
  publishedOn: "发布于",
  authorName: "华丽编辑",
  readingTime: "分钟阅读",
  shareArticle: "分享文章",
  relatedArticles: "相关推荐",
  tags: "标签",
  prevArticle: "上一篇",
  nextArticle: "下一篇",
  backToCategory: "返回分类",
};

export default article;